import { Box, Typography } from '@mui/material'

interface Props {
    label: string
    value: any
}

// Read-only label / value pair — a small uppercase label over a bold value.
// Use for read-only "spec sheet" detail displays instead of disabled inputs.
const UniversalDetailItem = ({ label, value }: Props) => (
    <Box>
        <Typography
            variant="caption"
            sx={{
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.07em',
                fontSize: 10.5,
                fontWeight: 600,
                display: 'block',
            }}
        >
            {label}
        </Typography>
        <Typography
            variant="body2"
            sx={{
                color: 'text.primary',
                fontWeight: 600,
                mt: 0.25,
                wordBreak: 'break-word',
            }}
        >
            {value || '—'}
        </Typography>
    </Box>
)

export default UniversalDetailItem
